module.exports = __webpack_public_path__ + "static/media/uaeu-logo.3b12cff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/uaeu-logo.png
// module id = 32
// module chunks = 0